<template>
  <v-card class="pa-4" outlined rounded="lg">
    <h6>Antifraude</h6>
    <template v-if="!active">
      <v-alert type="warning" text dense>
        Análise de antifraude não está ativa para este evento.
      </v-alert>

      <v-form v-model="valid" @submit.stop>
        <v-text-field
          v-model="startAnalysisDate"
          label="Data de início da análise"
          type="datetime-local"
          dense
          outlined
          :disabled="loading"
          :rules="[(v) => !!v || 'Data de início da análise é obrigatória']"
        ></v-text-field>

        <v-alert v-if="error" type="error" text dense>
          {{ error }}
        </v-alert>

        <div class="d-flex justify-space-between flex-wrap">
          <v-btn
            :disabled="loading"
            small
            color="info"
            depressed
            @click="runActivate(new Date())"
          >
            Ativar imediatamente
          </v-btn>
          <v-btn
            :disabled="!valid || loading"
            small
            color="success"
            depressed
            @click="runActivate(false)"
          >
            Agendar
          </v-btn>
        </div>
      </v-form>
    </template>
    <template v-else>
      <v-alert type="success" text dense>
        O antifraude
        <span v-if="isScheduled" class="font-weight-medium">
          está agendado para iniciar em
          {{ startAnalysisDate | date("DD/MM/YYYY HH:mm") }}</span
        >
        <span v-else class="font-weight-medium">
          está ativo desde {{ startAnalysisDate | date("DD/MM/YYYY HH:mm") }}.
        </span>
      </v-alert>

      <v-alert v-if="error" type="error" text dense>
        {{ error }}
      </v-alert>

      <div class="d-flex justify-space-between">
        <v-btn
          :disabled="loading"
          text
          small
          color="error"
          @click="runDeactivate"
        >
          Desativar
        </v-btn>
        <v-btn
          v-if="isScheduled"
          :disabled="loading"
          small
          color="info"
          @click="runActivate(new Date())"
          depressed
        >
          Iniciar imediatamente
        </v-btn>
      </div>
    </template>
  </v-card>
</template>

<script>
import PARTY from "@/services/admin/parties";
import moment from "moment";

export default {
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    active: false,
    loading: false,
    error: false,

    startAnalysisDate: 0,
    maximumAnalisysScore: 0,
  }),
  methods: {
    async runActivate(date) {
      try {
        this.loading = true;
        this.error = null;
        date = date || this.startAnalysisDate;

        await PARTY.update(this.party.id, {
          startAnalysisDate: moment(date).toISOString(),
        });

        this.startAnalysisDate = date;
        this.active = true;
      } catch (error) {
        this.error = error.message || error;
      } finally {
        this.loading = false;
      }
    },
    async runDeactivate() {
      try {
        this.loading = true;
        this.error = null;

        await PARTY.update(this.party.id, {
          startAnalysisDate: null,
        });

        this.active = false;
      } catch (error) {
        this.error = error.message || error;
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    isScheduled() {
      return moment().isBefore(this.startAnalysisDate);
    },
  },
  mounted() {
    this.active = !!this.party.startAnalysisDate;
    this.startAnalysisDate = this.party.startAnalysisDate;
    this.maximumAnalisysScore = this.party.maximumAnalisysScore;
  },
};
</script>

<style>
</style>